/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-design-system';
import { Link as BaseLink } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { jsx } from 'theme-ui';

export default function Link({
  to,
  href,
  onClick,
  variant = 'default',
  fallback = 'span',
  activeClassName,
  ...rest
}) {
  if (to) {
    return (
      <Box
        as={BaseLink}
        to={to}
        onClick={onClick}
        sx={{
          // These colors are the link defaults.
          // They can be overridden by the variant or via the sx prop on the component instance.
          color: 'primary',
          ':hover': { color: 'secondary' },
          variant: `link.${variant}`,
        }}
        activeClassName={activeClassName} // TODO doesn't work because it's not forwared to BaseLink.
        {...rest}
      />
    );
  }
  if (href) {
    return (
      <Box
        as={OutboundLink}
        href={href}
        onClick={onClick}
        sx={{
          // These colors are the link defaults.
          // They can be overridden by the variant or via the sx prop on the component instance.
          color: 'primary',
          ':hover': { color: 'secondary' },
          variant: `link.${variant}`,
        }}
        {...rest}
      />
    );
  }
  if (onClick) {
    return (
      <Box
        as="button"
        onClick={onClick}
        sx={{
          // These colors are the button defaults.
          // They can be overridden by the variant or via the sx prop on the component instance.
          color: 'primary',
          ':hover': { color: 'secondary' },
          variant: `link.${variant}`,
        }}
        {...rest}
      />
    );
  }
  // If we don't have a `to`, `href` or `onClick` prop, we don't add colors and hover.
  return <Box as={fallback} sx={{ variant: `link.${variant}` }} {...rest} />;
}
